if (!customElements.get('fg-registration-event')) {
    const TEALIUM_ACCOUNT_CREATED_PAYLOAD_KEY = 'tealium_account_created_payload';

    class FgRegistrationEvent extends HTMLElement {
        constructor() {
            super();
            this.email = this.dataset.email;
            this.emailSha256 = this.dataset.emailSha256;
            this.customerId = this.dataset.customerId;
            this.isNewAccount = localStorage.getItem('is-account-new') === 'true' ? true : false;
            this.optedInLoyalty = localStorage.getItem('loyalty-optin-on-registration') === 'true';
        }

        connectedCallback() {
            if (!this.isNewAccount) return;
            try {
                sessionStorage.setItem('tealium_account_created_pending', '1');
                sessionStorage.removeItem('tealium_account_created_consumed');
                sessionStorage.setItem(TEALIUM_ACCOUNT_CREATED_PAYLOAD_KEY, JSON.stringify({
                    User_LoginType: 'Standard',
                    User_Email_MD5: this.email || '',
                    User_Email_SHA256: this.emailSha256 || '',
                    User_Id: this.customerId || ''
                }));
            } catch (e) {
                console.warn('Unable to set account created flag', e);
            }

            localStorage.removeItem('is-account-new');
            if (this.optedInLoyalty) {
                try {
                    sessionStorage.setItem('tealium_loyalty_subscription', JSON.stringify({
                        emailMd5: this.email,
                        emailSha256: this.emailSha256
                    }));
                } catch (e) {
                    console.warn('Unable to set loyalty subscription flag', e);
                }
                localStorage.removeItem('loyalty-optin-on-registration');
            }

            // Create customer access token
            if(sessionStorage.getItem('customerAccessToken')) {
                localStorage.removeItem('c_profile');
            } else {
                this.createCustomerAccessToken();
            }
        }

        async createCustomerAccessToken(){
            if (!localStorage.getItem('c_profile')) return;
            let storefrontToken = document.getElementById('storefront-access-token')?.value;
            let storefrontEndpoint = document.getElementById('storefront-endpoint')?.value;

            // Fallback to localStorage if not found
            if (!storefrontToken) {
                storefrontToken = localStorage.getItem('storefrontToken');
                console.log('[DEBUG] storefrontToken from localStorage:', storefrontToken);
            }
            if (!storefrontEndpoint) {
                storefrontEndpoint = localStorage.getItem('storefrontEndpoint');
                console.log('[DEBUG] storefrontEndpoint from localStorage:', storefrontEndpoint);
            }


            if (!storefrontToken || !storefrontEndpoint) {
                console.error('Token o endpoint Storefront mancante');
                return;
            }

            // Retrieve customer data
            const encodedString = localStorage.getItem('c_profile');
            const decodedString = atob(encodedString);
            const dataObj = JSON.parse(decodedString);

            const input = {
                email: dataObj[0].e,
                password: dataObj[0].p
            }
            try {
                const response = await fetch(storefrontEndpoint, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": storefrontToken
                    },
                    body: JSON.stringify({
                        query: `#graphql
                                mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
                                    customerAccessTokenCreate(input: $input) {
                                        customerAccessToken {
                                            accessToken
                                        }
                                        customerUserErrors {
                                            message
                                        }
                                    }
                                }
                            `,
                        variables: { input }
                    })
                });

                const result = await response.json();
                const token = result.data?.customerAccessTokenCreate?.customerAccessToken;

                if (result.error) {
                    console.error(result.error);
                }

                if (token) {
                    sessionStorage.setItem("customerAccessToken", token.accessToken);
                    localStorage.removeItem('c_profile');
                }
            }
            catch (error) {
                    console.error('[DEBUG] Errore in createCustomerAccessToken:', error);
            }
        }

    }

    customElements.define('fg-registration-event', FgRegistrationEvent);
}
